//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['sport', 'competition', 'region', 'date', 'isLive', 'type', 'mode', 'title', 'title-icon', 'hideSubtitles', 'hideEmpty', 'oddsVisible'],
  data() {
    return {
      competitions: [],
      loading: true
    }
  },
  computed: {
    event_id() {
      return _.get(this.$store.state, 'inplay.event_id')
    },
    hash() {
      let params = {
        competition: this.competition,
        sport: this.sport,
        isLive: this.isLive,
        type: this.type,
        mode: this.mode,
        filters: false,
        lang: this.lang
      }
      params = _.omitBy(params, _.isNil)
      return new URLSearchParams(params).toString()
    }
  },
  watch: {
    hash: {
      handler: function (newVal, oldVal) {
        this.loading = true
        //console.log('events_widget', newVal, oldVal );
        if (tock.active('events_widget_live' + oldVal)) {
          //console.log('events_widget', newVal, oldVal );
          this.currentEvents = []
          this.loading = true
          tock.clear('events_widget_live' + oldVal)
        }
        this.initInterval()
      }
    }
  },
  mounted() {
    this.currentEvents = []
    this.loading = true
    this.initInterval()
  },
  beforeDestroy: function () {
    console.log('CHANGE clear', this.type, this.sport, this.hash)

    tock.clear('events_widget_live' + this.hash)
    emitter.off('events')
  },
  methods: {
    async initInterval() {
      this.fetchEvents()
      if (tock.active('events_widget_live' + this.hash)) {
        tock.clear('events_widget_live' + this.hash)
      }
      emitter.off('events')
      emitter.on('events', (e) => {
        if (_.size(_.intersection(e, this.currentEvents))) {
          if (!this.loading) {
            console.log('CHANGE emitter', this.type, this.sport)
            this.fetchEvents()
          }
        }
      })

      tock.setInterval(
        'events_widget' + this.hash,
        () => {
          console.log('CHANGE setInterval', this.type, this.sport, this.hash)
          this.fetchEvents()
        },
        30 * 1000
      )
    },
    async fetchEvents() {
      let params = {}
      if (this.date) params['date'] = this.date
      if (this.sport) params['sport'] = this.sport
      if (this.region) params['region'] = this.region
      if (this.competition) params['competition'] = this.competition
      params['live'] = true
      params['key'] = 'market_type'
      params['type'] = 'live'
      params['lang'] = this.lang
      params['filters'] = false
      console.log('events_widget_live', this.lang)
      this.$sportify().sportsbook.getEvents(params, (response) => {
        this.sportName = _.get(response, 'competitions[0].sport.name')
        this.setResponse(response)
      })
    },
    async setResponse(response) {
      this.defaultFilter = response.default_market_type
      if (!this.selectedFilter) {
        this.selectedFilter = response.default_market_type
      }
      if (!_.includes(_.map(response.market_filters, 'id'), this.selectedFilter)) {
        this.selectedFilter = response.default_market_type
      }
      this.filters = response.market_filters
      this.competitions = response.competitions
      this.currentEvents = _.chain(response.competitions).flatMap('events').map('id').value()

      this.loading = false
    }
  }
}
